export default __webpack_public_path__ + "static/media/Torsion_Sliding_1D2P_1700_asm_CP.50cef515.png";